import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
const tituloMensaje = environment.tituloSistema;
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar,
    public router: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
          // Error del lado del cliente
          errorMessage = `Error del cliente: ${error.error.message}`;
        } else {
          // Error del lado del servidor
          errorMessage = `Error del servidor: Código ${error.status}, Mensaje: ${error.message}`;
        }
        // Mostrar el mensaje de error usando MatSnackBar




        if (error.status === 403) {
          this.router.navigate(['login']);
          this.snackBar.open('La sesión ha expirado, por favor ingresar nuevamente', 'Cerrar', {
            duration: 5000,  // Duración en milisegundos (5 segundos)
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        } else {

          this.snackBar.open(errorMessage, 'Cerrar', {
            duration: 5000,  // Duración en milisegundos (5 segundos)
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        }

        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
